var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpFilterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90186 3.42299C1.90186 3.07288 2.18568 2.78906 2.53579 2.78906H12.6787C13.0288 2.78906 13.3126 3.07288 13.3126 3.42299V5.06221C13.3126 5.23033 13.2458 5.39158 13.1269 5.51046L9.06078 9.57663C8.94189 9.69552 8.8751 9.85676 8.8751 10.0249V11.6641L6.33938 14.1998V10.0249C6.33938 9.85676 6.27259 9.69552 6.1537 9.57663L2.08753 5.51046C1.96864 5.39158 1.90186 5.23033 1.90186 5.06221V3.42299Z",
    stroke: "#21314B",
    strokeWidth: 1.26786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpFilterIcon);
export default __webpack_public_path__ + "static/media/ExpFilterIcon.59013c1aac31284a908d8b2a43ccefe4.svg";
export { ForwardRef as ReactComponent };